import React from 'react';
import './App.css';
import VideoQuery from './containers/VideoQuery.js';
import SignIn from './containers/SignIn.js';


const App = ({authorized}) => (
  <div>
    {authorized? (
      <VideoQuery/> 
    ): (
      <SignIn/>
    )}
  </div>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js